import { useState } from 'react';
// Components/ui
import {
  AddressInput,
  InformationItemContainer,
  InformationItemInputsContainer,
  NoteDeleteButton,
  WarningsDisplay,
} from '../../../../../../layout';
import { Box } from '@mui/material';
import mailStyle from './style';
// Types
import { NewAddress } from '../../../../../../../../../../../utils/contactHelper';
import type { IContactAddress } from '@trii/types/dist/Contacts';
import { useEditEntity } from '../../../../../../../../../../../context/EditEntityContext';

type Props = {
  data: NewAddress | IContactAddress;
};

const Whatsapp = ({ data }: Props) => {
  const mode = 'edit';
  const { editEntity } = useEditEntity();
  const editEntityActions = editEntity.action;
  const editEntityState = editEntity.state;
  const [warnings, setWarnings] = useState<string[]>([]);

  return (
    <InformationItemContainer>
      <InformationItemInputsContainer>
        <Box sx={mailStyle.numberCountryContainer}>
          <Box sx={mailStyle.adressInputBox}>
            <AddressInput
              data={data}
              setWarnings={setWarnings}
              onChange={editEntityActions.handleAddressFieldChange}
            />
          </Box>
        </Box>
        <NoteDeleteButton
          mode={mode}
          addressData={data}
          handleNoteFieldChange={editEntityActions.handleNoteFieldChange}
          handleDeleteAddress={editEntityActions.handleDeleteAddress}
          isDeletingAddress={editEntityState.isDeletingAddress}
          replaceAddress={editEntityActions.replaceAddress}
        />
      </InformationItemInputsContainer>
      {warnings.length > 0 && <WarningsDisplay warnings={warnings} />}
    </InformationItemContainer>
  );
};

export default Whatsapp;
